import { parseEmployer } from '../employer';
import { applyTimezone, parseDate } from '../helpers/date';
import { parseProduct } from '../product';
import {
  DjangoEligibilityPolicy,
  EligibilityPolicy,
  parseEligibilityPolicy,
} from './eligibility_policy.model';
import { PricePolicy, parsePricePolicy } from './price_policy.model';

export class ProductCreditPolicy {
  id: string;
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy: string;
  modifiedBy: string;
  eligibilityPolicies: Array<EligibilityPolicy>;
  pricePolicies: Array<PricePolicy>;
  creditPolicyRelations: any;

  constructor(data: string | ProductCreditPolicy | DjangoProductCreditPolicy = {}) {
    if (data instanceof ProductCreditPolicy) {
      bindProductCreditPolicyData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoProductCreditPolicyData(this, { id: data });
    } else {
      bindDjangoProductCreditPolicyData(this, data);
    }
  }
}

export interface DjangoProductCreditPolicy {
  id?: string;
  name?: string;
  start_date?: Date;
  end_date?: Date;
  created_by?: string;
  modified_by?: string;
  credit_policy_relations?: any;
  eligibility_policies?: Array<DjangoEligibilityPolicy>;
  price_policies?: Array<PricePolicy>;
}

function bindProductCreditPolicyData(
  productCreditPolicy: ProductCreditPolicy,
  data: ProductCreditPolicy,
) {
  productCreditPolicy.id = data.id;
  productCreditPolicy.name = data.name;
  productCreditPolicy.startDate = data.startDate;
  productCreditPolicy.endDate = data.endDate;
  productCreditPolicy.createdBy = data.createdBy;
  productCreditPolicy.modifiedBy = data.modifiedBy;
  productCreditPolicy.creditPolicyRelations = data.creditPolicyRelations;
  productCreditPolicy.eligibilityPolicies = data.eligibilityPolicies;
  productCreditPolicy.pricePolicies = data.pricePolicies;
}

function bindDjangoProductCreditPolicyData(
  productCreditPolicy: ProductCreditPolicy,
  data: DjangoProductCreditPolicy,
) {
  productCreditPolicy.id = data.id;
  productCreditPolicy.name = data.name;
  productCreditPolicy.startDate = applyTimezone(parseDate(data.start_date), 0);
  productCreditPolicy.endDate = applyTimezone(parseDate(data.end_date), 0);
  productCreditPolicy.createdBy = data.created_by;
  productCreditPolicy.modifiedBy = data.modified_by;
  if (data?.credit_policy_relations?.length > 0) {
    productCreditPolicy.creditPolicyRelations = data?.credit_policy_relations.map((relations) => {
      if (relations.employer) {
        relations.employer = parseEmployer(relations.employer);
      }

      if (relations.product) {
        relations.product = parseProduct(relations.product);
      }

      return relations;
    });

    if (data?.eligibility_policies?.length > 0) {
      productCreditPolicy.eligibilityPolicies = data.eligibility_policies.map((eligibility) =>
        parseEligibilityPolicy(eligibility),
      );
    }

    if (data?.price_policies?.length > 0) {
      productCreditPolicy.pricePolicies = data.price_policies.map((policy) =>
        parsePricePolicy(policy),
      );
    }
  }
}
